import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../containers/Layout';
import Tab, { createId } from '../components/Tab';
import EditForm from '../containers/EditForm';
import BracketParticipants from '../containers/BracketParticipants';
import BracketConfigurator from '../containers/BracketConfigurator';
import { connect } from 'react-redux';
import { getBracketById } from '../redux/app';
import { navigateTo } from '../utils';

const EditTree = (props) => {
  const id = props.match.params.id;
  const key = props.match.params.id ? 'app.tree.settings' : 'app.tree.create';
  const participantsKey = `${key}.participants`;
  return (
    <Layout
      title={[
        !props.bracket.title && { messageId: 'app.tree.create.edit' },
        props.bracket.title && { messageId: props.bracket.title },
      ]}
    >
      <Tab
        tabs={[
          { messageId: `${key}.edit` },
          { messageId: participantsKey, disabled: !id },
          {
            messageId: `${key}.winners`,
            disabled:
              props.bracket.participants.length !==
              props.bracket.participantCount,
          },
        ]}
      >
        <EditForm
          defaultValues={{
            title: props.bracket.title,
            participantCount: props.bracket.participantCount,
            location: props.bracket.location,
            displayScores: props.bracket.displayScores,
            ...props.bracket.customAttributes,
          }}
          goToParticipants={(id) =>
            navigateTo(`/tree/edit/${id}${createId(participantsKey)}`, {
              method: 'replace',
            })
          }
          id={id}
        />
        <BracketParticipants
          title={props.bracket.title}
          id={id}
          nodes={props.bracket.nodes}
          participantCount={props.bracket.participantCount}
          participants={props.bracket.participants}
        />
        <BracketConfigurator id={id} />
      </Tab>
    </Layout>
  );
};

EditTree.propTypes = {
  match: PropTypes.object,
};

EditTree.propTypes = {
  bracket: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  bracket: getBracketById(state, ownProps.match.params.id),
});

export default connect(mapStateToProps)(EditTree);
